module.exports = __webpack_public_path__ + "static/media/icon_next.83951ef4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_next.svg
// module id = 319
// module chunks = 0